import { Injectable } from '@angular/core';
import {PictureQuestion} from "../interfaces/picture-question";
import {ImageService} from "../atoms/image/image.service";
import {ClickThePicQuestion} from "../interfaces/backend/click-the-pic-question";

@Injectable({
  providedIn: 'root'
})
export class GameParserService {

  constructor(
    private imageService: ImageService
  ) { }

  mapRawClickThePicQuestion(rawClickThePicQuestion: ClickThePicQuestion, gameId: string): PictureQuestion {
    return {
      id: rawClickThePicQuestion.id,
      gameId: gameId,
      // GET_CLICK_PIC_QUESTION does not query a question text
      question: '',
      answers: (rawClickThePicQuestion.answers ?? []).map(answer => ({id: answer.id, text: answer.text ?? ''})),
      image: this.imageService.mapRawImageData(rawClickThePicQuestion.image)
    }
  }

}
